import { Checkbox, DefaultButton, Dropdown, Panel } from "@fluentui/react";
import React, { useContext } from "react";

import { DefaultCountry, DefaultCustodyType, DefaultDataSource } from "../../api";
import { SettingsContext } from "../../Context/SettingsContext";

import styles from "./SettingsPanel.module.css";

export const ChatSettingsPanel: React.FC = () => {
    const { chatSettings, setChatSettings, isSettingsOpened, setIsSettingsOpened } = useContext(SettingsContext);

    return (
        <Panel
            headerText="Settings"
            isOpen={isSettingsOpened}
            isBlocking={false}
            onDismiss={() => setIsSettingsOpened(false)}
            closeButtonAriaLabel="Close"
            onRenderFooterContent={() => <DefaultButton onClick={() => setIsSettingsOpened(false)}>Close</DefaultButton>}
            isFooterAtBottom={true}
        >
            {chatSettings.isDevMode && (
                <>
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={chatSettings.showInitMessage}
                        label="Show system message(s)"
                        onChange={(_, checked) => setChatSettings({ ...chatSettings, showInitMessage: checked })}
                    />
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={chatSettings.showFunctions}
                        label="Show function calls"
                        onChange={(_, checked) => setChatSettings({ ...chatSettings, showFunctions: checked })}
                    />
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={chatSettings.showFunctionsResults}
                        label="Show function results"
                        onChange={(_, checked) => setChatSettings({ ...chatSettings, showFunctionsResults: checked })}
                    />
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={chatSettings.noCache}
                        label="Don't use cache"
                        onChange={(_, checked) => setChatSettings({ ...chatSettings, noCache: checked! })}
                    />
                </>
            )}
            <Checkbox
                className={styles.chatSettingsSeparator}
                checked={chatSettings.streaming}
                label="Streaming responses"
                onChange={(_, checked) => setChatSettings({ ...chatSettings, streaming: checked! })}
            />
            <Dropdown
                className={styles.chatSettingsSeparator}
                placeholder="Select the value"
                label="Response Mode"
                selectedKey={chatSettings.detailedResponses ? "detailed" : "answerOnly"}
                options={[
                    {
                        key: "answerOnly",
                        text: "Concise",
                        data: false
                    },
                    {
                        key: "detailed",
                        text: "Comprehensive",
                        data: true
                    }
                ]}
                onChange={(_, option) => setChatSettings({ ...chatSettings, detailedResponses: option?.data as boolean })}
            />
            <Dropdown
                className={styles.chatSettingsSeparator}
                placeholder="Select the value"
                label="Default Country"
                selectedKey={chatSettings.country}
                options={[
                    {
                        key: DefaultCountry.USA,
                        text: "USA",
                        data: DefaultCountry.USA
                    },
                    {
                        key: DefaultCountry.Canada,
                        text: "Canada",
                        data: DefaultCountry.Canada
                    }
                ]}
                onChange={(_, option) => setChatSettings({ ...chatSettings, country: option?.data as DefaultCountry })}
            />
            <Dropdown
                className={styles.chatSettingsSeparator}
                label="Default Custody type"
                placeholder="Select the value"
                selectedKey={chatSettings.custodyType}
                options={[
                    {
                        key: DefaultCustodyType.Own,
                        text: "Own",
                        data: DefaultCustodyType.Own
                    },
                    {
                        key: DefaultCustodyType.Rent,
                        text: "Rent",
                        data: DefaultCustodyType.Rent
                    },
                    {
                        key: DefaultCustodyType.Lease,
                        text: "Lease",
                        data: DefaultCustodyType.Lease
                    }
                ]}
                onChange={(_, option) => setChatSettings({ ...chatSettings, custodyType: option?.data as DefaultCustodyType })}
            />
            <Dropdown
                className={styles.chatSettingsSeparator}
                label="Data Source Preference"
                placeholder="Select the value"
                selectedKey={chatSettings.dataSource}
                options={[
                    {
                        key: DefaultDataSource.GDWOnly,
                        text: "ICE Global Data Warehouse",
                        data: DefaultDataSource.GDWOnly
                    },
                    {
                        key: DefaultDataSource.GDWWithAI,
                        text: "ICE GDW or Public Websites",
                        data: DefaultDataSource.GDWWithAI
                    }
                ]}
                onChange={(_, option) => setChatSettings({ ...chatSettings, dataSource: option?.data as DefaultDataSource })}
            />
        </Panel>
    );
};
